import { TextField } from '@customink/pigment-react';
import { type ChangeEventHandler, useEffect } from 'react';

import { WCIBMO_NAMES, zipCodeErrorMessage } from '@/constants';
import { useOrderQuantityType } from '@/hooks/useOrderQuantityType';
import { pageViewTag } from '@/utils/metrics';

export function ZipCodeTextField({
  isDisabled,
  isError,
  onChange,
  zipCode,
}: {
  isDisabled?: boolean;
  isError?: boolean;
  onChange: ChangeEventHandler<HTMLInputElement>;
  zipCode: string;
}) {
  const quantityType = useOrderQuantityType();
  useEffect(() => {
    if (isError && quantityType) {
      pageViewTag(
        `checkout/summary/${quantityType}/wcibmo/${WCIBMO_NAMES.INVALID_ZIP_CODE}`,
      );
    }
  }, [isError, quantityType]);

  return (
    <TextField
      aria-Label="zip code"
      disabled={isDisabled}
      error={isError}
      fullWidth
      helperText={!!isError && zipCodeErrorMessage}
      inputProps={{ 'data-testid': 'zip-code-text-field' }}
      name="zipCode"
      onChange={onChange}
      placeholder="Enter zip code"
      tabIndex={0}
      value={zipCode}
    />
  );
}
